import React from "react";
import styles from "./DestinationGallery.module.scss";
import NoDataFound from "../../NoDataFound/NoDataFound";
import imgNotFound from "../../../assets/images/single-image.png"

const DestinationGallery = ({ footerDestinations }) => {

  if(!footerDestinations) {
    return null;
  }
  return (
    <section className="" style={{background: '#ffffff'}}>
      <div className="container">
        <h3 className='new_ui_heading'>
          Top Himachal Destinations
        </h3>
        <div className={`${styles.destination_gallery} m_0`}>
          {footerDestinations?.length > 0 ? (
            footerDestinations?.map((item, index) => {
              return (
                <a
                  href={`/destination/${item?.slug}`}
                  className={styles[`destination${index + 1}`]}
                  key={index}
                >
                  <img src={  item.featuredImage ? item.featuredImage : imgNotFound} alt={item?.name} />
                  <span>{item?.name}</span>
                </a>
              );
            })
          ) : (
            <NoDataFound />
          )}
        </div>
      </div>
    </section>
  );
};

export default DestinationGallery;
